"use client";

import { createContext, ReactNode, useContext } from "react";
import { Logger } from "../models";
import { setDefaultLogger } from "../defaultLogger";

const context = createContext<Logger | null>(null);
export function LoggingProvider({
  logger,
  children,
}: {
  logger: Logger;
  children: ReactNode;
}) {
  setDefaultLogger(logger);
  return <context.Provider value={logger}>{children}</context.Provider>;
}

export function useLogger(name?: string) {
  const logger = useContext(context);
  if (!logger) {
    throw new Error("No logger found in context");
  }
  if (name) {
    return logger.child(name);
  }
  return logger;
}
